import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSD: CultureInfo = {
  name: 'en-SD',
  displayName: 'English (Sudan)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SD',
  parent: CultureInfoEn
};
